// extracted by mini-css-extract-plugin
export var localeSelector = "_bc-0";